import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Text} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import styleSheet from './styles';

const PrivacyPolicyScreen = () => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <SafeAreaView style={styles.container}>
      <Text>Privacy Policy</Text>
    </SafeAreaView>
  );
};

export default PrivacyPolicyScreen;
